import type { ReactNode } from "react";
import { GenericLabel } from "./GenericLabel";

type Props = {
  title?: ReactNode;
  imageUrl?: string;
  size?: number;
};

export const EntityLabel = ({ title, imageUrl, size }: Props) => (
  <GenericLabel title={title} imageUrl={imageUrl} size={size} avatarIcon="fa-shield" />
);
